export default __webpack_public_path__ + "static/HelveticaNeue-578dccd40a5b5b948ec903851fa8b80a.woff2";